import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  AppBar,
  Autocomplete,
  Box,
  CardContent,
  TextField,
  Toolbar,
} from "@mui/material";
import ReactPaginate from "react-paginate";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import NoRecordMessage from "../../common/components/NoRecordMessage";
import TableSkeleton from "../../common/components/TableSkeleton";
import GroupCard from "../components/GroupCard";
import SearchBox from "../../common/components/SearchBox";
import { useTheme } from "@mui/material/styles";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

import NewGroupDialog from "../components/NewGroupDialog";
import {
  getVotingDepartGroupScores,
  getVotingGroups,
} from "../../../store/voting/actions";
import DepartmentLeftSide from "../components/DepartmentLeftSide";
import GroupScoreCard from "../components/GroupScoreCard";

const DepartmentGroupScores = (props) => {
  const {
    getVotingDepartGroupScores,
    user,
    votingDepartmentGroupScores,
    votingGroups,
    getVotingGroups,
  } = props;
  const { hasPermissions } = useRequiredAuth();
  useEffect(() => {
    document.title = `IPPIS - Groups(${votingDepartmentGroupScores.length}) | Voting`;
  },[votingDepartmentGroupScores]);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [searchTeam, setSearchTeam] = useState("");
  const [group, setGroup] = useState(null);
  const [filteredRequests, setFilteredRequests] = useState([...votingDepartmentGroupScores]);
  const theme = useTheme();

  useEffect(() => {
    if (!votingGroups.length) getVotingGroups(setLoading1);
  }, []);

  useEffect(() => {
    const filtered = [...votingDepartmentGroupScores].filter(
      ({ names, phoneNumber, positionName, unitName }) =>
        (names || "").toLowerCase().includes(searchTeam.toLowerCase()) ||
        (phoneNumber || "").toLowerCase().includes(searchTeam.toLowerCase()) ||
        (positionName || "").toLowerCase().includes(searchTeam.toLowerCase()) ||
        (unitName || "").toLowerCase().includes(searchTeam.toLowerCase())
    );
    setFilteredRequests(filtered);
    paginate(filtered);
  }, [searchTeam, votingDepartmentGroupScores]);

  const [paginatedItems, setPaginatedItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);

  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 10;

  const paginate = (items) => {
    const endOffset = itemOffset + itemsPerPage;
    setPaginatedItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  };
  useEffect(() => {
    paginate(filteredRequests);
  }, [itemOffset, itemsPerPage, filteredRequests]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % filteredRequests.length || 0;

    setItemOffset(newOffset);
  };
  const onSearch = (term) => {
    setSearchTeam(term);
  };

  return (
    <div className="row mx-0">
      <div className="col-2">
        <DepartmentLeftSide />
      </div>
      <div className="col-10 mt-2">
        <AppBar
          position="static"
          elevation={0}
          style={{ overflow: "hidden" }}
          className="app-bar w-100"
        >
          <Toolbar className="row">
            <div className="col-lg-7">
              <Typography
                variant="h6"
                noWrap
                component="div"
                // sx={{ display: { xs: "none", sm: "block" } }}
              >
                <span>VOTING</span>
                <span className="mr-1 ml-1" style={{ color: "#2a7790" }}>
                  <span
                    className="material-icons  text-dark"
                    style={{ position: "relative", top: "4px" }}
                  >
                    chevron_right
                  </span>
                </span>

                <span>Department</span>
                <span className="mr-1 ml-1" style={{ color: "#2a7790" }}>
                  <span
                    className="material-icons  text-dark"
                    style={{ position: "relative", top: "4px" }}
                  >
                    chevron_right
                  </span>
                </span>

                <span style={{ color: "rgb(7, 142, 206)" }}>
                  <span style={{ color: "rgb(7, 142, 206)" }}>
                    Group Scores
                  </span>
                </span>
              </Typography>
            </div>

            <div className="col-lg-5">
              <div className="d-flex justify-content-right  align-items-right">
                <Autocomplete
                  sx={{ width: 500 }}
                  className="mr-2"
                  size="small"
                  id="group"
                  defaultValue={null}
                  value={group}
                  options={votingGroups}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={(event, group) => {
                    setGroup(group);
                    getVotingDepartGroupScores(setLoading, group?.id);
                  }}
                  getOptionLabel={(option) => option.name}
                  renderOption={(props, group) => (
                    <Box component="li" {...props} key={group.id}>
                      {group.name}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      style={{
                        width: "100%",
                        height: "35px!important",
                        position: "relative",
                        borderRadius: "8px",
                        padding: "1px!important",
                      }}
                      {...params}
                      label="Filter By"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "filterStatus", // disable autocomplete and autofill
                      }}
                    />
                  )}
                />

                <SearchBox
                  onSearch={(search) => {
                    onSearch(search);
                  }}
                  placeholder="Search…"
                />
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <div
          style={{
            padding: theme.spacing(0.4),
            height: "auto",
            maxHeight: "auto",
            margin: "1.2em",
            backgroundColor: "#fff",
            borderRadius: "0.5rem",
            overflow: "visible",
            boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
            MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
          }}
        >
          <CardContent
            style={{
              padding: ".1em",
              height: "auto",
              minHeight: "auto",
              overflow: "auto",
            }}
          >
            <table className="table-striped table-hover table-sm  fixTableHead">
              <thead>
                <tr style={{ backgroundColor: "#f0f2f5" }}>
                  <th scope="col" className="text-left">
                    No
                  </th>
                  <th scope="col" className="text-left">
                    Names
                  </th>
                  <th scope="col" className="text-left">
                    Group Name
                  </th>
                  <th scope="col" className="text-left">
                    FiscalYear
                  </th>

                  <th scope="col" className="text-left">
                    Position
                  </th>
                  <th scope="col" className="text-left">
                    Unit
                  </th>

                  <th scope="col" className="text-left">
                    Votes
                  </th>
                   <th scope="col" className="text-left">
                    Behavior Rate
                  </th>

                  <th scope="col" className="text-right">
                    <span className="mr-3">Actions</span>
                  </th>
                </tr>
              </thead>

              {loading ? (
                <TableSkeleton cols={9} />
              ) : (
                <tbody>
                  {paginatedItems.map((item, index) => (
                    <GroupScoreCard
                      user={user}
                      item={item}
                      index={index + 1}
                      key={item.id}
                    />
                  ))}
                </tbody>
              )}
            </table>

            {!!paginatedItems.length &&
              votingDepartmentGroupScores.length >= itemsPerPage && (
                <div
                  className="justify-content-center mt-2"
                  style={{ overflow: "hidden" }}
                >
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel={
                      <>
                        <span className="pr-1 d-none d-md-inline">Next</span>
                        <i className="fas fa-angle-double-right"></i>
                      </>
                    }
                    previousLabel={
                      <>
                        <i className="fas fa-angle-double-left"></i>
                        <span className="pl-1  d-none d-md-inline">
                          Previous
                        </span>
                      </>
                    }
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    pageCount={pageCount}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1 mt-1"
                    previousLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1 mt-1"
                    nextLinkClassName="btn btn-outline-info btn-sm ml-1 mt-1"
                    activeLinkClassName="active"
                  />
                </div>
              )}

            <NoRecordMessage
              isEmpty={!filteredRequests.length && !loading}
              title="No Results found"
            />
          </CardContent>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  user,
  votingDepartmentGroupScores,
  votingGroups,
}) => {
  return { user, votingDepartmentGroupScores, votingGroups };
};
const mapDispatchToProps = {
  getVotingDepartGroupScores,
  getVotingGroups,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DepartmentGroupScores);
